import React, { useEffect, useState } from 'react';
import { BundleProps } from 'utils/types';
import { StyledPlaySimpleBundle } from './style';
import { Box } from '@mui/system';
import {
  EBadgePosition,
  EBadgeType,
  EBundlesInternalViewModel,
} from 'utils/enums';
import BundlePrice from '../BundlePrice';
import { BadgeData } from 'components/Badge/types';
import { RibbonBadge } from 'components/Badge/RibbonBadge/RibbonBadge';
import { MainProduct } from './MainProduct/MainProduct';

export const PlaySimpleBundle: React.FC<BundleProps> = ({
  price,
  productList,
  badges = [],
  salePercentage = 0,
  bundleButtonColor,
}) => {
  const [ribbonBadge, setRibbonBadge] = useState<any>(null);
  useEffect(() => {
    if (badges.length > 0) {
      const foundRibbon = badges.find((badge: BadgeData) => {
        const badgeType = badge.badge ? badge.badge.type : badge.type;
        return badgeType === EBadgeType.RIBBON;
      });

      setRibbonBadge(foundRibbon?.badge?.ribbon || foundRibbon?.ribbon);
    }
  }, [badges]);

  return (
    <StyledPlaySimpleBundle
      ribbonBadgeColor={
        ribbonBadge ? ribbonBadge.backgroundColor : { colorOne: '#8B34C3' }
      }
    >
      <Box className="container">
        {productList.length > 0 && (
          <MainProduct
            productImage={productList[0].images.product}
            textColor={productList[0].textFontColorHex}
            quantityDisplay={productList[0].quantityDisplay}
            strokedSaleQuantity={productList[0].strokedSaleQuantity}
            salePercentage={salePercentage}
          />
        )}
        <BundlePrice
          price={price}
          type={EBundlesInternalViewModel.PLAY_SIMPLE}
          buttonColor={bundleButtonColor}
        />
      </Box>
      {ribbonBadge && (
        <>
          <RibbonBadge
            text={ribbonBadge.text}
            textColor={ribbonBadge.textColor}
            backgroundColor={ribbonBadge.backgroundColor}
            position={EBadgePosition.CENTER}
            viewModel={EBundlesInternalViewModel.PLAY_SIMPLE}
          />
          <Box className="ribbonBadge-arrow"></Box>
        </>
      )}
    </StyledPlaySimpleBundle>
  );
};
